import request from '../utils/request';

export default {
  //公告列表
  getAnnouncement(data) {
    return request.request({
      url: '/announcement/list',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //公告详情
  getAnnouncementDetail(data) {
    return request.request({
      url: '/announcement/show',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //租赁算力
  rental(data) {
    return request.request({
      url: '/home/rental',
      method: "post",
      headers: {
        // Authorization: address,        
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //首页的各项数据 
  getIndexBaseInfo(data) {
    return request.request({
      url: '/home/base',
      method: "post",
      headers: {
        // Authorization: address,        
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  getIndexGoodsInfo(data) {
    return request.request({
      url: '/home/all',
      method: "post",
      headers: {
        // Authorization: address,        
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },

  //用户信息
  getUserInfo(data) {
    return request.request({
      url: '/user/userInfo',
      method: "post",
      headers: {
        // Authorization: address
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //注册
  register(data) {
    return request.request({
      url: '/member/register',
      method: "post",
      headers: {
        // Authorization: address,
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //用户信息/登录
  auth(data) {
    return request.request({
      url: '/member/auth',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 绑定上级（茶）
  chaBindParent(data) {
    return request.request({
      url: '/member/bind',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //提现记录
  withdrawList(data) {
    return request.request({
      url: '/offline/withdrawList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //算力明细列表
  powerList(data) {
    return request.request({
      url: '/ledger/powerList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //USDT明细列表
  usdtList(data) {
    return request.request({
      url: '/ledger/usdtList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //虚拟币明细列表
  tokenList(data) {
    return request.request({
      url: '/ledger/tokenList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //团队数据
  teamInfo(data) {
    return request.request({
      url: '/team/all',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //提现申请
  withdrawCash(data) {
    return request.request({
      url: '/offline/withdrawCash',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //提现信息
  withdrawInfo(data) {
    return request.request({
      url: '/offline/withdrawFee',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //租赁比例
  prepareRental(data) {
    return request.request({
      url: '/home/prepareRental',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //账变类型
  actionGet(data) {
    return request.request({
      url: '/ledger/actionGet',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //团队收益列表
  profitList(data) {
    return request.request({
      url: '/team/profitList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //充值记录
  rechargeList(data) {
    return request.request({
      url: '/offline/rechargeList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //提现手续费
  withdrawFee(data) {
    return request.request({
      url: '/offline/withdrawFee',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //服务器信息
  serversInfo(data) {
    return request.request({
      url: '/servers/info',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //服务器购买
  serversRental(data) {
    return request.request({
      url: '/servers/rental',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //服务器购买列表
  serversList(data) {
    return request.request({
      url: '/order/list',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //团队统计
  serviceTeam(data) {
    return request.request({
      url: '/servers/team',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //ETC金额数据
  etcInfo(data) {
    return request.request({
      url: '/user/etcInfo',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //ETC提现
  etcSubmit(data) {
    return request.request({
      url: '/user/etcSubmit',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //预约
  reservation(data) {
    return request.request({
      url: '/Transaction/reservation',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //ETC兑换提交
  etcExchange(data) {
    return request.request({
      url: '/user/etcExchange',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //捡漏
  leak(data) {
    return request.request({
      url: '/Transaction/leak',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //传统交易
  tradition(data) {
    return request.request({
      url: '/Transaction/tradition',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //我的资产
  assets(data) {
    return request.request({
      url: '/ledger/assets',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //资产明细列表
  coinList(data) {
    return request.request({
      url: '/ledger/coinList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //订单列表
  orderList(data) {
    return request.request({
      url: '/order/list',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //预约下单
  createReservation(data) {
    return request.request({
      url: '/order/createReservation',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //捡漏下单
  createLeak(data) {
    return request.request({
      url: '/order/createLeak',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //传统下单
  createTradition(data) {
    return request.request({
      url: '/order/createTradition',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //能量值互转
  transferEnergy(data) {
    return request.request({
      url: '/ledger/transferEnergy',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //资产资金变动类型
  coinAction(data) {
    return request.request({
      url: '/ledger/coinAction',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //订单筛选类型
  orderAction(data) {
    return request.request({
      url: '/order/orderAction',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //更新订单hash
  updateOrder(data) {
    return request.request({
      url: '/order/updateOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //获取订单
  getOrder(data) {
    return request.request({
      url: '/order/getOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //申请分区
  partitionApply(data) {
    return request.request({
      url: '/user/partitionApply',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //操作订单，卖出或租赁
  handleOrder(data) {
    return request.request({
      url: '/order/handleOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //产品列表
  productsList(data) {
    return request.request({
      url: '/order/productsList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //创建订单
  createOrder(data) {
    return request.request({
      url: '/order/create',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //SMH兑换提交
  smhExchange(data) {
    return request.request({
      url: '/user/smhExchange',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //SMH金额数据
  smhInfo(data) {
    return request.request({
      url: '/user/smhInfo',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //SMH提现
  smhSubmit(data) {
    return request.request({
      url: '/user/smhSubmit',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //ALEO金额数据
  aleoInfo(data) {
    return request.request({
      url: '/user/aleoInfo',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //ALEO提现
  aleoSubmit(data) {
    return request.request({
      url: '/user/aleoSubmit',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //热门商品详情
  getPopularInfo(data) {
    return request.request({
      url: '/home/getPopularInfo',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //寄售商品详情
  getTransferInfo(data) {
    return request.request({
      url: '/home/getTransferInfo',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //商品关联地区
  getProductAddres(data) {
    return request.request({
      url: '/home/getProductAddres',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //购买热门商品
  create(data) {
    return request.request({
      url: '/order/create',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //购买寄售商品
  transferOrder(data) {
    return request.request({
      url: '/order/transferOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //抢购商品列表
  getPopularList(data) {
    return request.request({
      url: '/Product/getPopularList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //寄售商品列表
  getTransferList(data) {
    return request.request({
      url: '/Product/getTransferList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //提货
  pickupOrder(data) {
    return request.request({
      url: '/order/pickupOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //寄售商品
  transfer(data) {
    return request.request({
      url: '/order/transfer',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //nft列表
  getNftList(data) {
    return request.request({
      url: '/user/getNftList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //取消寄售
  cancel(data) {
    return request.request({
      url: '/order/cancel',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //茶友
  getChaList(data) {
    return request.request({
      url: '/user/getChaList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //分享奖励
  getUserBalanceLog(data) {
    return request.request({
      url: '/user/getUserBalanceLog',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //获取充值信息
  getAddress(data) {
    return request.request({
      url: '/ledger/getAddress',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //修改个人信息
  setUserInfo(data) {
    return request.request({
      url: '/user/setUserInfo',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //赠送
  giveaway(data) {
    return request.request({
      url: '/order/giveaway',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //获取物流信息
  getTracking(data) {
    return request.request({
      url: '/order/getTracking',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //转账茶宝说明
  chabaoInfo(data) {
    return request.request({
      url: 'ledger/getGiftDesc',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //转账茶宝
  chabaoGift(data) {
    return request.request({
      url: '/ledger/chabaoGift',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  //操作记录
  getOperateLog(data) {
    return request.request({
      url: '/user/getOperateLog',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 我的状态
  getMyNftList(data) {
    return request.request({
      url: '/user/getMyNftList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 上传头像
  upload(data) {
    return request.request({
      url: '/common/upload',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 获取福利信息
  getNewbieWeal(data) {
    return request.request({
      url: '/Airdrop/getNewbieWeal',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 领取新人茶权
  setNewbieWeal(data) {
    return request.request({
      url: '/Airdrop/setNewbieWeal',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 领取超级福利
  setSuperWeal(data) {
    return request.request({
      url: '/Airdrop/setSuperWeal',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 合成中心
  getSynthesisList(data) {
    return request.request({
      url: '/synthesis/list',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 合成中心详情
  getSynthesisDetail(data) {
    return request.request({
      url: '/synthesis/detail',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 合成中心提交
  synthesisCreate(data) {
    return request.request({
      url: '/synthesis/create',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 存储列表
  pledgeList(data) {
    return request.request({
      url: '/Pledge/list',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 存储详情
  pledgeDetail(data) {
    return request.request({
      url: '/Pledge/detail',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 获取指定产品订单
  holdProductList(data) {
    return request.request({
      url: '/pledge/holdProductList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 提交存储
  createPledge(data) {
    return request.request({
      url: '/pledge/create',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 我的茶矿
  teamine(data) {
    return request.request({
      url: '/pledge/teamine',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 解除
  removePledge(data) {
    return request.request({
      url: '/pledge/remove',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 收取
  collectPledge(data) {
    return request.request({
      url: '/pledge/collect',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 标记茶宝转账
  frozenTransfer(data) {
    return request.request({
      url: '/ledger/frozenTransfer',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 寄售分类
  getPopularType(data) {
    return request.request({
      url: '/Product/getPopularType',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 我的关注
  getTransferCollectList(data) {
    return request.request({
      url: '/product/getTransferCollectList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 寄售详情
  getTransferDetail(data) {
    return request.request({
      url: '/Product/getTransferDetail',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 收藏
  collect(data) {
    return request.request({
      url: '/market/collect',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 寄售公告
  marketAnnouncement(data) {
    return request.request({
      url: '/market/announcement',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 发布求购
  setBuying(data) {
    return request.request({
      url: '/market/setBuying',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 求购列表
  getBuyingList(data) {
    return request.request({
      url: '/market/buyingList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 出售求购
  sellBuying(data) {
    return request.request({
      url: '/market/sellBuying',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 持有订单
  getHoldProductOrderList(data) {
    return request.request({
      url: '/Product/getHoldProductOrderList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 求购详情
  getBuyingDetail(data) {
    return request.request({
      url: '/market/getBuyingDetail',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 取消求购
  cancelBuying(data) {
    return request.request({
      url: '/market/cancelBuying',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 配置信息
  getMarketConfig(data) {
    return request.request({
      url: '/market/getMarketConfig',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 产品最大价
  getBuyingMaxPrice(data) {
    return request.request({
      url: '/market/getBuyingMaxPrice',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 锁单
  setTransferLock(data) {
    return request.request({
      url: '/market/setTransferLock',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 获取待支付数量
  getWaitPayOrderCount(data) {
    return request.request({
      url: '/user/getWaitPayOrderCount',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 取消待支付
  setCancelWaitPayOrder(data) {
    return request.request({
      url: '/user/setCancelWaitPayOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 待支付列表
  getWaitPayOrderList(data) {
    return request.request({
      url: '/user/getWaitPayOrderList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 我的求购列表
  getMyBuyingList(data) {
    return request.request({
      url: '/user/getBuyingList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac获取配置
  getTeacConfig(data) {
    return request.request({
      url: '/teac/getConfig',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac交易列表
  getTeacList(data) {
    return request.request({
      url: '/teac/getTeacList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac发布购买
  setTeacBuying(data) {
    return request.request({
      url: '/teac/setBuying',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac发布出售
  setTeacSell(data) {
    return request.request({
      url: '/teac/setSell',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac出售购买
  setTeacSellOrder(data) {
    return request.request({
      url: '/teac/setSellOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac求购出售
  setTeacBuyOrder(data) {
    return request.request({
      url: '/teac/setBuyOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac求购取消
  cancelTrade(data) {
    return request.request({
      url: '/teac/cancelTrade',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac求购记录
  getUserTeacList(data) {
    return request.request({
      url: '/teac/getUserTeacList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 福利兑换
  getWelfareRedeConfig(data) {
    return request.request({
      url: '/exchange/getWelfareRedeConfig',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 福利兑换提交
  submitWelfare(data) {
    return request.request({
      url: '/exchange/submitWelfare',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 获取公告分类
  gettype(data) {
    return request.request({
      url: '/announcement/gettype',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac兑换列表
  getTeacExList(data) {
    return request.request({
      url: '/exchange/getTeacList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac兑换详情
  getTeacExDetail(data) {
    return request.request({
      url: '/exchange/getTeacDetail',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac兑换提交
  getTeacExOrder(data) {
    return request.request({
      url: '/exchange/getTeacOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teap兑换列表
  getTeapExList(data) {
    return request.request({
      url: '/teap/getTeapList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teap兑换详情
  getTeapExDetail(data) {
    return request.request({
      url: '/teap/getTeapDetail',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teap兑换提交
  getTeapExOrder(data) {
    return request.request({
      url: '/teap/getTeapOrder',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 首页横幅
  getRowBanner(data) {
    return request.request({
      url: '/home/getBanner',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 福利兑换列表
  getWelfareRedeList(data) {
    return request.request({
      url: '/exchange/getWelfareRedeList',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 福利兑换详情
  getWelfareRedeDetail(data) {
    return request.request({
      url: '/exchange/getWelfareRedeDetail',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  addPledgeProduct(data) {
    return request.request({
      url: '/pledge/addPledgeProduct',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  setRenew(data) {
    return request.request({
      url: '/pledge/setRenew',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  teacGift(data) {
    return request.request({
      url: '/ledger/teacGift',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  teacRemit(data) {
    return request.request({
      url: '/teac/transferToCha',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  teacRemitDesc(data) {
    return request.request({
      url: '/teac/transferDesc',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 激活码使用
  activateCode(data) {
    return request.request({
      url: '/codeno/activate',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 激活码列表
  activateCodeList(data) {
    return request.request({
      url: '/codeno/list',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 生成激活码
  activateCodeGenerate(data) {
    return request.request({
      url: '/codeno/generate',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 剩余激活数量
  activateCodeRemaining(data) {
    return request.request({
      url: '/codeno/remaining',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // 社区统计
  getCommunityCount(data) {
    return request.request({
      url: '/codeno/count',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac天使转账
  teacAngelTransfer(data) {
    return request.request({
      url: '/ledger/teacAngelTransfer',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
  // teac生态发展转账
  teacEcologyTransfer(data) {
    return request.request({
      url: '/ledger/teacEcologyTransfer',
      method: "post",
      headers: {
        'Accept-Language': localStorage.getItem('language') || 'zh-cn',
      },
      data
    })
  },
}